import React, { useContext } from 'react';

export const routeParamsContext = React.createContext({});

export const useRouteParams = () => useContext(routeParamsContext);
